import React from 'react';

function Home() {
  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto', textAlign: 'left' }}>
      <h1 style={{ textAlign: 'center', marginBottom: '20px' }}>Rafaros Track</h1>

      <section style={{ marginBottom: '20px' }}>
        <h2>Présentation de l'application</h2>
        <p>
          Rafaros Track est un système de suivi GPS en temps réel pour vos objets ou véhicules.
          Vous pouvez visualiser la position d'un tracker sur la carte et consulter sa vitesse.
        </p>
      </section>

      <section>
        <h2>Notice d'utilisation</h2>
        <ol>
          <li>Allez sur la page <strong>TrackerMap</strong>.</li>
          <li>Saisissez l'ID du tracker que vous souhaitez suivre.</li>
          <li>
            Pour définir une <strong>destination</strong> à atteindre, cliquez sur <strong>Destination</strong> et
             transmettez la position initiale. ⚠️ Seuls les utilisateurs disposant du mot de passe
            d'administration peuvent utiliser cette fonctionnalité.
          </li>
          <li>La carte se mettra à jour automatiquement avec la position et la vitesse du tracker.</li>
        </ol>
        <p>
          ⚠️ Assurez-vous que votre tracker est actif et que vous utilisez le mot de passe correct
          pour initialiser la position.
        </p>
      </section>
    </div>
  );
}

export default Home;
